<template>
    <object :data="SVGIcon" type="image/svg+xml">
        <img :src="GIFIcon" /> <!-- fallback gif just in case animated svg fails -->
    </object>
</template>

<script>
export default {
    name: 'AlertIcon',
    props: {
        usage: {
            type: String,
            required: true,
            validator: (value) => {
                return ['success', 'info', 'warning', 'error', 'stop'].includes(value)
            }
        }
    },
    computed: {
        SVGIcon() {
            switch (this.usage) {
                case 'success':
                    return require('@/assets/icon-success-ani.svg')
                case 'info':
                    return require('@/assets/icon-info-ani.svg')
                case 'warning':
                    return require('@/assets/icon-warning-ani.svg')
                case 'error':
                    return require('@/assets/icon-error-ani.svg')
                case 'stop':
                    return require('@/assets/icon-error-octagon-ani.svg')
            }
        },
        GIFIcon() {
            switch (this.usage) {
                case 'success':
                    return require('@/assets/icon-success-ani.gif')
                case 'info':
                    return require('@/assets/icon-info-ani.gif')
                case 'warning':
                    return require('@/assets/icon-warning-ani.gif')
                case 'error':
                    return require('@/assets/icon-error-ani.gif')
                case 'stop':
                    return require('@/assets/icon-error-octagon-ani.gif')
            }
        }
    }
}
</script>